import { ThankYouDialogComponent } from './../../dialogs/thank-you-dialog/thank-you-dialog.component';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/api.service';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/services/general.service';
import { MatDialog } from '@angular/material';
import { LoginService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-create-lift',
  templateUrl: './create-lift.component.html',
  styleUrls: ['./create-lift.component.scss'],
})
export class CreateLiftComponent implements OnInit {
  liftForm: FormGroup;
  isSubmitting = false;
  constructor(
    public api: ApiService,
    private formBuilder: FormBuilder,
    private titleService: Title,
    private router: Router,
    public generalService: GeneralService,
    public dialog: MatDialog,
    public loginService: LoginService,
    private meta: Meta
  ) {}

  ngOnInit() {
    this.liftForm = this.formBuilder.group({
      fromAddress: ['', Validators.required],
      toAddress: ['', Validators.required],
      departureDate: ['', Validators.required],
      dhh: ['', Validators.required],
      dmm: ['', Validators.required],
      noOfChild: [''],
      noOfAdults: [''],
    });
  }

  submitTripQuote() {
    if (!this.loginService.isAuthenticated()) {
      this.generalService.openSignInDialog(
        'Before submitting the form, you need to login.'
      );
    } else {
      this.isSubmitting = true;
      this.api.createLift(this.liftForm.value).subscribe(
        r => {
          this.isSubmitting = false;
          const dialogRef = this.dialog.open(ThankYouDialogComponent, {
            width: '400px',
            data: {
              body: 'Track request to join a Trip in Profile page',
            },
          });

          dialogRef.afterClosed().subscribe(result => {
            this.router.navigate(['/']);
          });
        },
        error => {
          console.log(error);
          this.isSubmitting = false;
        }
      );
    }
  }
}
